import type { Report } from '../../model/report';
import type { ReportPillar2Settings } from '../../model/reportPillar2Settings';
import type { Pillar2FilingMeta } from './executePillar2Filing';

/**
 * Builds filing metadata for the BFF resolver, sourcing jurisdiction from the Report
 * and obligation type / nil return flag from ReportPillar2Settings.
 */
export function resolvePillar2FilingMeta(
    report: Report | null | undefined,
    settings: ReportPillar2Settings | null | undefined
): Pillar2FilingMeta {
    const jurisdiction = settings?.efileJurisdiction?.trim() ?? report?.jurisdiction?.trim();
    const obligationType = settings?.defaultFilingObligationType?.trim();
    const isNilReturn = settings?.isNilReturn ?? false;
    return { jurisdiction, obligationType, isNilReturn };
}

export type Pillar2SubmitUnavailableMessageKey =
    | 'pillar2SubmitUnavailableXml'
    | 'pillar2SubmitUnavailableJson'
    | 'pillar2SubmitUnavailableGeneric';

/**
 * Picks the translation key for the message shown in place of Submit when the jurisdiction does not support
 * e-file submission, based on the e-file format delivered with the report's Pillar Two settings.
 */
export function getSubmitUnavailableMessageKey(efileFormat: string | null | undefined): Pillar2SubmitUnavailableMessageKey {
    switch (efileFormat?.trim().toUpperCase()) {
        case 'XML':
            return 'pillar2SubmitUnavailableXml';
        case 'JSON':
            return 'pillar2SubmitUnavailableJson';
        default:
            return 'pillar2SubmitUnavailableGeneric';
    }
}
